interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  const start = Math.max(1, page - 2);
  const end = Math.min(totalPages, start + 4);
  for (let i = start; i <= end; i += 1) pages.push(i);

  const btnBase =
    "flex h-9 min-w-9 cursor-pointer items-center justify-center rounded-md border px-3 text-sm transition-colors";

  return (
    <nav className="mt-8 flex flex-wrap items-center justify-center gap-2" aria-label="分页">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className={`${btnBase} ${
          page === 1
            ? "cursor-not-allowed border-background-200 text-foreground-300"
            : "border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
        }`}
      >
        <i className="ri-arrow-left-s-line" /> 上一页
      </button>

      {start > 1 && (
        <>
          <button type="button" onClick={() => onChange(1)} className={`${btnBase} border-background-300 text-foreground-700 hover:border-primary-400`}>
            1
          </button>
          {start > 2 && <span className="px-1 text-foreground-400">…</span>}
        </>
      )}

      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`${btnBase} ${
            p === page
              ? "border-primary-600 bg-primary-600 text-white"
              : "border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
          }`}
        >
          {p}
        </button>
      ))}

      {end < totalPages && (
        <>
          {end < totalPages - 1 && <span className="px-1 text-foreground-400">…</span>}
          <button type="button" onClick={() => onChange(totalPages)} className={`${btnBase} border-background-300 text-foreground-700 hover:border-primary-400`}>
            {totalPages}
          </button>
        </>
      )}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className={`${btnBase} ${
          page === totalPages
            ? "cursor-not-allowed border-background-200 text-foreground-300"
            : "border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
        }`}
      >
        下一页 <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}